<div class="col formscreen">
    <rr-start-logo color="inverse" routerLink="/"></rr-start-logo>
    <form class="loginform" [formGroup]="forgottpwForm" (ngSubmit)="onSubmit()">
        <div class="col headline">
            <h1>New Password</h1>
            <span>Enter your email to receive a password reset link.</span>
        </div>
        <div class="col withlink tiny">
            <rr-input
                label="E-Mail"
                type="email"
                [required]="true"
                formControlName="email"
            ></rr-input>
            <a href="/login">Log in?</a>
        </div>
        <rr-btn
            type="Primary"
            (btnClick)="onSubmit()"
            [disabled]="
                forgottpwForm.invalid ||
                !forgottpwForm.value.email ||
                forgottpwForm.value.email.length === 0
            "
            >Send</rr-btn
        >
        <!-- <rr-divider></rr-divider>
    <span class="tiny"
      >By logging in you agree to our
      <a target="_blank" href="/terms">terms</a> and have read the
      <a target="_blank" href="/privacy">privacy policy</a>.</span
    > -->
    </form>
</div>
<div class="rightsideimage"></div>
<rr-spinner *ngIf="!hidespinner"></rr-spinner>
